import { Flex, IconFont, Popover, Text, Tooltip } from '@byecode/ui'
import type { ArgumentsSchema } from '@lighthouse/core'
import { PAGE_PARAMETER_TYPE_OPTIONS } from '@lighthouse/shared'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import { ParameterFormDropdown } from './ParameterFormDropdown'

const Tag = styled.div`
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 10px;
    line-height: 14px;
    white-space: nowrap;
    color: var(--color-gray-600);
    background-color: #26415a0f;
`

const IconButton = styled.button.attrs({ type: 'button' })`
    border: none;
    outline: none;
    padding: 0;
    display: flex;
    align-items: center;
`

interface ParameterItemProps {
    data: ArgumentsSchema
    existingNames: string[]
    enableDefaultValue?: boolean
    onDeleteItem?: (id: string) => void
    onUpdateItem?: (data: ArgumentsSchema) => void
}

export const ParameterItem = ({ data, existingNames, enableDefaultValue, onDeleteItem, onUpdateItem }: ParameterItemProps) => {
    const type = useMemo(() => PAGE_PARAMETER_TYPE_OPTIONS.find(item => item.value === data.innerType)?.label || '未知', [data.innerType])

    const [open, setOpen] = useState(false)

    return (
        <Flex gap={8} alignItems="center" py={9}>
            <Tag>{type}</Tag>
            <Text mr="auto" size={14} lineHeight="22px">
                {data.name}
            </Text>
            <Popover
                returnFocus={false}
                width={324}
                withinPortal
                position="left-start"
                autoUpdate={false}
                offsetOptions={292}
                opened={open}
                onChange={setOpen}
            >
                <Popover.Target>
                    <Tooltip title="编辑">
                        <IconButton>
                            <IconFont type="edit" fill="var(--color-gray-400)" />
                        </IconButton>
                    </Tooltip>
                </Popover.Target>
                {open && (
                    <ParameterFormDropdown
                        existingNames={existingNames}
                        data={data}
                        enableDefaultValue={enableDefaultValue}
                        onUpdateItem={onUpdateItem}
                    />
                )}
            </Popover>
            <Tooltip title="删除">
                <IconButton onClick={() => onDeleteItem?.(data.id)}>
                    <IconFont type="Trash" fill="var(--color-gray-400)" />
                </IconButton>
            </Tooltip>
        </Flex>
    )
}
